const SUPPORTED_PMS_PROVIDERS = new Set(["ownerrez", "hostaway", "hospitable"]);

export const normalizePmsProvider = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  return SUPPORTED_PMS_PROVIDERS.has(normalized) ? normalized : "";
};

export const resolveGuestFormProvider = (request) => {
  const metadataProvider = normalizePmsProvider(
    request?.Metadata?.provider || request?.Metadata?.pmsProvider,
  );
  if (metadataProvider) return metadataProvider;

  const matchRequestId = String(request?.MatchRequestId || "").trim().toLowerCase();
  const matchRequestProvider = normalizePmsProvider(matchRequestId.split(":", 1)[0]);
  if (matchRequestProvider) return matchRequestProvider;

  const sourceProject = String(request?.SourceProject || "").trim().toLowerCase();
  for (const provider of SUPPORTED_PMS_PROVIDERS) {
    if (sourceProject.includes(provider)) return provider;
  }

  return "";
};

export const isHostawayGuestForm = (request) => resolveGuestFormProvider(request) === "hostaway";
